// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3OX4_","requiredAsterisk":"Info_requiredAsterisk__3Mejw"};